// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
  height: 100vh;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
main{
  min-height: 100vh;
}
h3{
  padding : 1rem 0;
}

h1{
  font-size: 1.8rem;
  padding: 1rem 0;
}
h2{
  font-size: 1.4rem;
  padding: 0.5rem 0;
}
.rating span{
  margin: 0.1rem;
}
::-webkit-scrollbar {
  width: 1px;
}
#username{
  color : white!important;
}
/* Add this in a file like src/styles.css and import it in App.js */

.center-container {
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}

.login-container {
  width: 100%;
  max-width: 600px;
  padding: 40px 20px;
  /* border: 1px solid #ddd; */
  border-radius: 8px;
  background-color: #fff;
  /* box-shadow: 0 0 10px rgba(0, 0, 0, 0.1); */
  text-align: center;
}

h4 {
  margin-bottom: 20px;
  font-weight: bold;
}

.form-group {
  margin-bottom: 20px;
  text-align: left;
}

.input-group-prepend .input-group-text {
  background-color: #eee;
  border-right: 0;
}

.form-control {
  border-left: 0;
  border-radius: 0;
}

.btn-primary {
  background-color: #ff3366;
  border: none;
  padding: 10px;
  font-size: 16px;
  width: 100%;
}

p {
  margin-top: 15px;
  font-size: 14px;
}

p a {
  /* color: #ff3366; */
  text-decoration: none;
}

p a:hover {
  text-decoration: underline;
}

.otp-inputs {
  display: flex;
  justify-content: space-between;
}

.otp-input {
  width: 20%;
  padding: 10px;
  text-align: center;
  font-size: 18px;
  border: 1px solid #ddd;
  border-radius: 4px;
}

.feedback-item {
  border: 1px solid #ccc;
  margin: 10px;
  padding: 10px;
  border-radius: 5px;
}

.feedback-entry {
  border-top: 1px solid #eee;
  margin-top: 10px;
  padding-top: 10px;
}
th {
  position: sticky;
  top: 0;
  background: white !important;
}

.txt-wrap{
  max-width: 200px;
  max-height: 100px;
  text-overflow: ellipsis;
  overflow: scroll;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;AACA;EACE,UAAU;AACZ;AACA;EACE,uBAAuB;AACzB;AACA,mEAAmE;;AAEnE;EACE,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,4BAA4B;EAC5B,kBAAkB;EAClB,sBAAsB;EACtB,6CAA6C;EAC7C,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,UAAU;EACV,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,MAAM;EACN,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,gBAAgB;AAClB","sourcesContent":[".App {\n  text-align: center;\n  height: 100vh;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\nmain{\n  min-height: 100vh;\n}\nh3{\n  padding : 1rem 0;\n}\n\nh1{\n  font-size: 1.8rem;\n  padding: 1rem 0;\n}\nh2{\n  font-size: 1.4rem;\n  padding: 0.5rem 0;\n}\n.rating span{\n  margin: 0.1rem;\n}\n::-webkit-scrollbar {\n  width: 1px;\n}\n#username{\n  color : white!important;\n}\n/* Add this in a file like src/styles.css and import it in App.js */\n\n.center-container {\n  height: 100vh;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.login-container {\n  width: 100%;\n  max-width: 600px;\n  padding: 40px 20px;\n  /* border: 1px solid #ddd; */\n  border-radius: 8px;\n  background-color: #fff;\n  /* box-shadow: 0 0 10px rgba(0, 0, 0, 0.1); */\n  text-align: center;\n}\n\nh4 {\n  margin-bottom: 20px;\n  font-weight: bold;\n}\n\n.form-group {\n  margin-bottom: 20px;\n  text-align: left;\n}\n\n.input-group-prepend .input-group-text {\n  background-color: #eee;\n  border-right: 0;\n}\n\n.form-control {\n  border-left: 0;\n  border-radius: 0;\n}\n\n.btn-primary {\n  background-color: #ff3366;\n  border: none;\n  padding: 10px;\n  font-size: 16px;\n  width: 100%;\n}\n\np {\n  margin-top: 15px;\n  font-size: 14px;\n}\n\np a {\n  /* color: #ff3366; */\n  text-decoration: none;\n}\n\np a:hover {\n  text-decoration: underline;\n}\n\n.otp-inputs {\n  display: flex;\n  justify-content: space-between;\n}\n\n.otp-input {\n  width: 20%;\n  padding: 10px;\n  text-align: center;\n  font-size: 18px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n}\n\n.feedback-item {\n  border: 1px solid #ccc;\n  margin: 10px;\n  padding: 10px;\n  border-radius: 5px;\n}\n\n.feedback-entry {\n  border-top: 1px solid #eee;\n  margin-top: 10px;\n  padding-top: 10px;\n}\nth {\n  position: sticky;\n  top: 0;\n  background: white !important;\n}\n\n.txt-wrap{\n  max-width: 200px;\n  max-height: 100px;\n  text-overflow: ellipsis;\n  overflow: scroll;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
